import LikedContened from './LikedContened';

export default LikedContened;
